import type { HTMLAttributes } from "react";
import { cx } from "@/utils/cx";

/**
 * Brand wordmark — „axigon". Nahrazuje výchozí UntitledLogo z UUI kitu, ale drží
 * stejný export `UntitledLogo`, takže UUI komponenty (sidebar, mobile-header) ho
 * importují beze změny.
 */
export const UntitledLogo = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => {
    return (
        <div
            {...props}
            className={cx("flex items-center font-bold tracking-tight text-primary", className)}
        >
            <span className="text-lg">axigon</span>
        </div>
    );
};

export default UntitledLogo;
